export default [{
  name: 'bancoapia',
  namespaced: true,
  state: {
    model: {
      Pessoa: {
        PF: {},
        PJ: {},
        TipoPessoa: null,
        PessoaDadosContato: {},
        PessoaEndereco: {},
        PessoaBanco: {},
      },
      Parcela: {},
      DadosIniciais: {},
      DadosBureau: {},
      DadosLimite: {},
      Proposta: {},
      DadosSocios: []
    },
  },
  mutations: {
    model (state, obj) {
      state.model = obj
    },
  },
  getters: {
    model (state) {
      return state.model
    },
  },
  actions: {
    clearModel ({ commit }) {
      const data = {
        Pessoa: {
          PF: {},
          PJ: {},
          TipoPessoa: null,
          PessoaDadosContato: {},
          PessoaEndereco: {},
          PessoaBanco: {},
        },
        Parcela: {},
        DadosIniciais: {},
        DadosBureau: {},
        DadosLimite: {},
        Proposta: {}
      }
      commit('model', data)
    }
  },
}]
